<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PT7RjJ/tc-custom/9780226044859.jpg?1732165491217" alt="This image is the cover for the book General History of Quadrupeds"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">General History of Quadrupeds
      </h1>
      <p class="bookDescription body article font2">
        <p>In the late eighteenth century, the British took greater interest than ever before in observing and recording all aspects of the natural world. Travelers and colonists returning from far-flung lands provided dazzling accounts of such exotic creatures as elephants, baboons, and kangaroos. The engraver Thomas Bewick (1753–1828) harnessed this newfound interest by assembling the most comprehensive illustrated guide to nature of his day.</p><p><i>A General History of Quadrupeds</i>, first published in 1790, showcases Bewick’s groundbreaking engraving techniques that allowed text and images to be published on the same page. From anteaters to zebras, armadillos to wolverines, this delightful volume features engravings of over four hundred animals alongside descriptions of their characteristics as scientifically understood at the time. <i>Quadrupeds</i> reaffirms Bewick’s place in history as an incomparable illustrator, one whose influence on natural history and book printing still endures today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Bewick, Yann Martel
      </h2>
      
      <p class="authorDescription body article"><P><B>Thomas Bewick</B> (1753–1828) was a master of book illustration and wood engraving from Newcastle upon Tyne, England. His many works include the <I>History of British Birds</I>.</P><P><B>Yann Martel</B> is the author of <I>The Life of Pi</I> and <I>A Twentieth Century Shirt</I>, the latter forthcoming in 2009.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b4953f86